import { ca } from '@cian/analytics';
import { ILogger } from '@cian/logger';
import { defaultTo } from 'ramda';

import {
  selectAnalyticsOfferStatus,
  selectAnalyticsExtraOfferIds,
} from '../../../ServicePickerWidget/selectors/analytics';
import { selectIsMobileLayout, selectLayoutOSType } from '../../../ServicePickerWidget/selectors/layout';
import { selectMicrofrontendHostName } from '../../../Microfrontend';
import { selectWebviewHostActionName } from '../../../Webview';
import { TReduxStore } from '../../types';

import { IAppAnalytics, IAppAnalyticsBaseParams, IAppAnalyticsParams, EAppAnalyticsSiteType } from './types';
import { getAppMeta } from './utils';

interface IParams {
  getState: TReduxStore['getState'];
  logger: ILogger;
}

export const createAnalytics = ({ getState, logger }: IParams): IAppAnalytics => ({
  send<T>(params: IAppAnalyticsParams<T>) {
    const state = getState();

    const defaultCategory = selectAnalyticsOfferStatus(state);
    const defaultExtraOfferIds = selectAnalyticsExtraOfferIds(state);

    const pageType = defaultTo('webview', selectMicrofrontendHostName(state));

    const isMobile = selectIsMobileLayout(state);
    const osType = selectLayoutOSType(state);
    const webSiteType = isMobile ? EAppAnalyticsSiteType.Mobile : EAppAnalyticsSiteType.Desktop;
    const appSiteType = osType === 'ios' ? EAppAnalyticsSiteType.iOS : EAppAnalyticsSiteType.Android;

    const webviewHostActionName = selectWebviewHostActionName(state);
    const appMeta = getAppMeta({ logger, platform: osType });

    // Подробнее про требования для событий можно прочитать тут
    // https://conf.cian.tech/pages/viewpage.action?pageId=1080262781
    const analyticsParams: IAppAnalyticsBaseParams & IAppAnalyticsParams<T> = {
      // для событий без смены страницы всегда используется oldevent
      name: 'oldevent',
      category: defaultTo(defaultCategory, params.category),
      action: params.action,
      page: {
        pageType,
        siteType: pageType === 'webview' ? appSiteType : webSiteType,
        extra: {
          ...defaultExtraOfferIds,
          ...defaultTo({}, params.extra),
          hostActionName: webviewHostActionName,
        },
      },
    };

    if (params.label) {
      analyticsParams.label = params.label;
    }

    if (params.products) {
      analyticsParams.products = params.products;
    }

    if (appMeta) {
      analyticsParams.page.extra.appMeta = appMeta;
    }

    ca('eventSite', analyticsParams);
  },
});
